import { EventMode, menuDefinition } from '@/types/menu-setting';

// 指定賽事多個運動選單，才顯示子選單，其餘單一運動不顯示子選單
export const MULTI_SPORT_MENU_MODE = ['M0', 'M1', 'M4', 'M8', 'M13', 'M14', 'M21'];

// 排除上方多運動選單後的單一運動，不顯示子選單
export const SINGLE_SPORT_MENU_MODE = (Object.keys(menuDefinition) as EventMode[])
	.filter(mode => !MULTI_SPORT_MENU_MODE.includes(mode));